(() => {
  const WRAPPER_SELECTOR = '.att-pdp-yotpo-rating[data-att-rating-average]';
  const SUMMARY_SELECTOR = '.yotpo-sr-bottom-line-summary';
  const COUNT_SELECTOR =
    '.yotpo-sr-bottom-line-text--right-panel, .yotpo-bottom-line-text';

  function formattedAverage(wrapper) {
  let average = Number.parseFloat(wrapper.dataset.attRatingAverage);

  if (!Number.isFinite(average) || average <= 0) {
    const ariaLabel = wrapper
      .querySelector(SUMMARY_SELECTOR)
      ?.getAttribute('aria-label');

    const ariaMatch = ariaLabel?.match(
      /(\d+(?:\.\d+)?)\s*(?:out(?:\s+of)?|\/)\s*5/i
    );

    average = ariaMatch ? Number.parseFloat(ariaMatch[1]) : NaN;
  }

  return Number.isFinite(average) && average > 0
    ? `${average.toFixed(1)}/5`
    : null;
}

  function enhanceWrapper(wrapper) {
    const value = formattedAverage(wrapper);
    if (!value) return;

    wrapper.querySelectorAll(SUMMARY_SELECTOR).forEach((summary) => {
      if (summary.querySelector('.att-pdp-rating-average')) return;

      const average = document.createElement('span');
      average.className = 'att-pdp-rating-average';
      average.textContent = value;
      average.setAttribute('aria-label', `Average rating ${value.replace('/', ' out of ')}`);

      const count = summary.querySelector(COUNT_SELECTOR);
const insertionPoint = count
  ? Array.from(summary.children).find(
      (child) => child === count || child.contains(count)
    )
  : null;

summary.insertBefore(average, insertionPoint || null);
    });
  }

  function initialize(root = document) {
    const wrappers = [];

    if (root.matches?.(WRAPPER_SELECTOR)) wrappers.push(root);
    root.querySelectorAll?.(WRAPPER_SELECTOR).forEach((wrapper) => {
      wrappers.push(wrapper);
    });

    wrappers.forEach(enhanceWrapper);
  }

  function start() {
    initialize();

    /* Yotpo renders asynchronously and may re-render after Shopify section updates. */
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return;

          const wrapper = node.matches?.(WRAPPER_SELECTOR)
            ? node
            : node.closest?.(WRAPPER_SELECTOR);

          if (wrapper) enhanceWrapper(wrapper);
          initialize(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target);
  });
})();

